import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal, Button, Upload, Form, Input } from "antd";
import {
  editCarouselSlider,
  getCarouselList,
  getImageLink,
} from "actions/carousel";

const EditSliderModal = ({
  visible,
  setVisible,
  slider,
  filters,
  fetchCarouselList,
  fetchImageLink,
  editSlider,
}) => {
  const [file, setFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const defaultValues = {
    seqNum: slider?.seqNum,
    sliderName: slider?.sliderName,
    imageLink: slider?.imageLink,
    urlLink: slider?.urlLink,
  };
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(defaultValues);
  }, [slider]);

  const onFinish = async (values) => {
    if (imageFile) {
      const formData = new FormData();
      formData.append("file", imageFile);

      const { data } = await fetchImageLink(formData);
      if (data?.fileLink) {
        values["imageLink"] = data.fileLink;
      }
    }

    await editSlider(slider.carouselId, slider.id, values);
    setFile(null);
    setImageFile(null);
    setVisible(false);
    fetchCarouselList(filters);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      title="Add Slider"
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[]}
    >
      <Form
        form={form}
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 400,
        }}
        initialValues={defaultValues}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Seq No."
          name="seqNum"
          rules={[
            {
              required: true,
              message: "Please input sequence number!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Slider Name"
          name="sliderName"
          rules={[
            {
              required: true,
              message: "Please input slider name!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Upload Image"
          name="imageLink"
          rules={[
            {
              required: imageFile || slider?.imageLink ? false : true,
              message: "Please upload slider image!",
            },
          ]}
          valuePropName="file"
          getValueFromEvent={(event) => {
            return event?.fileList[0];
          }}
        >
          <Upload
            maxCount={1}
            listType="picture"
            accept="image/jpg"
            customRequest={(e) => {
              setImageFile(e.file);
              const imageUrl = URL.createObjectURL(e.file);
              setFile(imageUrl);
            }}
            showUploadList={false}
          >
            <Button>Click here to Upload New Image</Button>
          </Upload>

          {file && <img src={file} width={200} height={100} alt="Slider_Image" />}
          {!file && <img src={slider?.imageLink} width={200} height={100} alt="Slider_Image" />}
        </Form.Item>

        <Form.Item
          label="URL Link"
          name="urlLink"
          rules={[
            {
              required: true,
              message: "Please input URL link!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 12,
            span: 16,
          }}
        >
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

function mapStateToProps(state) {
  const {
    Carousel: { filters },
  } = state;
  return {
    filters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchCarouselList: bindActionCreators(getCarouselList, dispatch),
    fetchImageLink: bindActionCreators(getImageLink, dispatch),
    editSlider: bindActionCreators(editCarouselSlider, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSliderModal);
